import type { IDocument } from 'modules/documents/common/documents.types'
import { MAX_FILE_SIZE } from 'services/documents/consts'

import type { DocumentData } from './types'

export const validateFileSizes = (files: File[]) => {
  const validFiles: File[] = []
  const oversizedFiles: File[] = []

  files.forEach(file => {
    if (file.size > MAX_FILE_SIZE) {
      oversizedFiles.push(file)
    } else {
      validFiles.push(file)
    }
  })

  return { validFiles, oversizedFiles }
}

export const getDocumentsFormatted = ({ documents }: { documents: Array<DocumentData> }): IDocument[] =>
  documents.map(file => ({
    id: file?.id || '',
    fileName: file?.fileName || '',
    size: file?.size || 0,
    createdAt: file?.createdAt ? new Date(file.createdAt) : new Date(),
    status: file?.status,
  }))
